import type { PropsWithChildren } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuthStore } from '../features/auth/auth.store';
import { AgreementGate } from '../features/agreement/AgreementGate';

/**
 * Route guard for this portal — unlike the mobile app (which has public
 * pages and checks auth inline per-page), everything here except /login
 * requires a signed-in therapist, so a single wrapper is simpler than
 * repeating the check on every page.
 *
 * Two gates, in order: authentication, then the signed Therapist Agreement
 * (ADR-019). Nesting the legal gate here rather than in App.tsx means a route
 * added later is covered by default — the failure mode of forgetting to wrap a
 * new page should be "inaccessible", never "accessible without a contract".
 */
export function RequireAuth({ children }: PropsWithChildren) {
  const accessToken = useAuthStore((s) => s.tokens?.accessToken);
  if (!accessToken) return <Navigate to="/login" replace />;
  return <AgreementGate>{children}</AgreementGate>;
}
